/**
 * Created by Raul on 20/07/2018.
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {NotificationsResource} from '../service/notifications.resource';
import {NotificationModel} from '../service/notification.model';
import {Router} from '@angular/router';
import {ModalDirective, ToastService} from 'ng-uikit-pro-standard';

@Component({

  selector: 'app-notifications-modal',
  templateUrl: 'notifications-modal.component.html'
})
export class NotificationsModalComponent implements OnInit {
  @ViewChild('notificationsModal')
  public modal: ModalDirective;
  public notifications: NotificationModel[] = [];

  constructor(private notificationsResource: NotificationsResource,
              private router: Router,
              private toastMsg: ToastService) {
  }

  ngOnInit() {
  }

  loadNotifications() {
    this.notificationsResource.getNotifications().then(res => {
      this.notifications = res;
      this.notifications.sort(function(a, b) {
        return a._id - b._id;
      }).reverse();
    }, err => this.toastMsg.error('No se han podido cargar sus notificaciones.'));
  }

  seenNotification(notification: NotificationModel, navegar: boolean = false) {
    this.notificationsResource.seenNotifications({_id: notification._id});
    if (navegar && notification.app_path)
      this.router.navigate(['/portal' + notification.app_path]);
  }
}
